import type { TOC } from '@ember/component/template-only';
import EditionForm, {
  type Args
} from 'parog-web/components/consultation-frequency/edition-form';

export default <template>
  <EditionForm
    @patient={{@patient}}
    @sourceJeId={{@sourceJeId}}
    @isReadOnly={{@isReadOnly}}
    @afterCompleted={{@afterCompleted}}
    @afterCancel={{@afterCancel}}
    @consultationType='physical'
    @title='Santé physique > Consultations'
  />
</template> satisfies TOC<Args>;
